import { 
  SET_CONTENT_HTML,
  ADD_SOURCE,
  ADD_LINK,
  SET_SOURCE_ORDER_INDEX,
  EDIT_SOURCE,
  SET_AUTH_DATA,
  SET_DOCS,
  SET_DOC_DATA,
  SET_DOC_SAVED,
  RENAME_DOC,
  CREATE_DOC,
  SET_CURRENT_DOC,
  UPDATE_CURRENT_DOC
} from './mutation-types.js'

import getOrderedLinks from '@/shared/getOrderedSources.js'
import Promise from 'bluebird'
import identifier from 'identifier'
import moment from 'moment'

import { updateUserMetadata } from '@/shared/userMetadata.js'

export default {
  setContentHtml ({commit, state}, content) {
    const sourcesIndexes = getOrderedLinks(content, state.links, Object.keys(state.sources))
    commit(SET_CONTENT_HTML, {contentHtml: content})
    Object.keys(sourcesIndexes).forEach((sourceId) => {
      commit(SET_SOURCE_ORDER_INDEX, {id: sourceId, index: sourcesIndexes[sourceId]})
    })
    commit(SET_DOC_SAVED, false)
  },
  addSource ({commit}, {content}) {
    const id = identifier(10)
    return new Promise((resolve) => {
      commit(ADD_SOURCE, {id, content})
      resolve(id)
    })
  },
  editSource ({commit}, {content, sourceId}) {
    return new Promise((resolve) => {
      commit(EDIT_SOURCE, {content, sourceId})
      resolve()
    })
  },
  addLink ({commit}, {sourceId}) {
    const id = identifier(10)
    const content = {sources: [sourceId]}
    return new Promise((resolve) => {
      commit(ADD_LINK, {id, content})
      resolve(id)
    })
  },
  authenticated ({ commit }, { authData, profile }) {
    commit(SET_AUTH_DATA, {
      isAuthorized: true,
      authToken: authData.idToken,
      profileName: profile.email,
      userId: profile.user_id
    })
    commit(SET_DOCS, profile.user_metadata.docs)
  },
  unauthenticated({ commit }) {
    commit(SET_AUTH_DATA, {
      isAuthorized: false,
      authToken: null,
      profileName: null,
      userId: null
    })
  },
  saveDoc({ commit, state }) {
    let docName = state.docName

    if (docName === null) {
      const checkDocName = (name, suffix) => {
        if (suffix > 1) {
          name = `${name}-${suffix}`
        }
        const found = state.docs.filter(d => d.name.toLowerCase() === name.toLowerCase())
        return !!found.length
      }
      const defaultBase = 'Статья ' + moment().format('DD.MM.YYYY')

      let num = 1
      while (checkDocName(defaultBase, num)) {
        num++
      }
      if (num > 1) {
        docName = `${defaultBase}-${num}`
      } else {
        docName = defaultBase
      }
      commit(SET_CURRENT_DOC, docName)
    }

    const currentDoc = {
      name: docName,
      content: state.contentHtml,
      sources: state.sources,
      links: state.links
    }
    const oldDocs = state.docs.filter(d => d.name !== docName)
    const dump = {
      docs: [currentDoc, ...oldDocs]
    }
    return updateUserMetadata(state.userId, dump, state.authToken).then(() => {
      commit(SET_DOC_SAVED, true)
      commit(UPDATE_CURRENT_DOC)
    })
  },
  loadDoc({ commit, state }, docName = 'default') {
    return new Promise((resolve, reject) => {
      const doc = state.docs.find(d => d.name === docName)
      if (doc) {
        commit(SET_DOC_DATA, doc)
        commit(SET_DOC_SAVED, true)
        commit(SET_CURRENT_DOC, docName)
        resolve()
      } else {
        reject(new Exception('Document not found'))
      }
    })
  },
  renameDoc({ commit, state }, { oldDocName, newDocName }) {
    commit(RENAME_DOC, { oldDocName, newDocName })
  },
  createDoc({ commit }, docName) {
    commit(CREATE_DOC, docName)
  }
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js